<span id="scale-plan__btn" target="_blank" [title]="title">
  <fa-icon [icon]="faStar"></fa-icon>
  {{ 'SUBSCRIPTION.SCALE_PLAN' | translate }}
</span>
